// extracted by mini-css-extract-plugin
module.exports = {"root":"X9bA5UHQT6AHvn6eNf0R"};